import { Injectable } from '@angular/core';
import { IConfigEmpresaRes } from '@core/interfaces/request-response/empresa.dto.interface';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EmpresaService {
  protected empresaConfigData = new BehaviorSubject<IConfigEmpresaRes | null>(null);
  get empresaConfigData$() {
    return this.empresaConfigData.asObservable();
  }
  getEmpresaData(): IConfigEmpresaRes | null {
    return this.empresaConfigData.getValue();
  }
  setEmpresaData(empresa: IConfigEmpresaRes) {
    this.empresaConfigData.next(empresa);
  }
}
